module.exports = __webpack_public_path__ + "img/interface OneB Studio_1 prew.671e1804.jpg";